/**
 * 获取支付-请求日期和关单日期
 * @param addMinutes 指定增加的分钟数[当前时间+增加分钟数=关单时间]
 */
export function getCurrentDateTime(addMinutes = 0) {
  const date = new Date();

  // 在当前时间上加指定分钟
  if (addMinutes) {
    date.setMinutes(date.getMinutes() + addMinutes);
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return {
    date: `${year}${month}${day}`, // 年月日
    dateTime: `${year}${month}${day}${hours}${minutes}${seconds}`, // 年月日时分秒
  };
}

/**
 * 获取支付-请求流水号
 * @param prefix 前缀，默认为 "HQ"
 */
export function generateOrderNo(prefix = "HQ") {
  const date = new Date();
  // 格式化时间：YYYYMMDDHHMMSS
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");
  const second = String(date.getSeconds()).padStart(2, "0");

  const dateTimeStr = `${year}${month}${day}${hour}${minute}${second}`;

  // 生成一个 10~12 位随机数字，保证不重复
  const randomStr = Math.random().toString().slice(2, 8);

  return `${prefix}${dateTimeStr}${randomStr}`;
}

/**
 * 获取支付-支付链接地址---商付通
 * @param prefix 商付通返回数据
 */
export function getPayUrlSFT(prefix) {
  try {
    const obj = JSON.parse(prefix);
    return obj?.payInfo?.payUrl || "";
  } catch (err) {
    console.error("JSON解析失败：", err);
    return "";
  }
}
/**
 * 获取支付-支付链接地址---Smartpay
 * @param raw Smartpay返回数据
 */
export function getPayUrlSmartpay(raw) {
  let inner = {};

  try {
    // raw.msg 是 JSON 字符串，需要解析
    inner = JSON.parse(raw.msg || "{}");
  } catch (e) {
    console.error("JSON解析失败:", e);
  }

  return {
    code: inner.code || raw.code || null,
    msg: inner.msg || "",
    data: {
      payUrl: inner.result?.pay_url || "",
      qr_code: inner.result?.qr_code || "",
    },
  };
}
